/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetNetworkConfigurationErrorResponse,
  GetNetworkConfigurationResponse,
  GetNetworksConfigurationParams,
} from './api.schemas';

import { api } from '../util/http';

export const getNetworksConfiguration = (
  name: string,
  params?: GetNetworksConfigurationParams,
  signal?: AbortSignal,
) => {
  return api<GetNetworkConfigurationResponse>({
    url: `/api/networks/${name}/configuration`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetNetworksConfigurationQueryKey = (
  name?: string,
  params?: GetNetworksConfigurationParams,
) => {
  return [`/api/networks/${name}/configuration`, ...(params ? [params] : [])] as const;
};

export const getGetNetworksConfigurationQueryOptions = <
  TData = Awaited<ReturnType<typeof getNetworksConfiguration>>,
  TError = GetNetworkConfigurationErrorResponse,
>(
  name: string,
  params?: GetNetworksConfigurationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNetworksConfiguration>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNetworksConfigurationQueryKey(name, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNetworksConfiguration>>> = ({
    signal,
  }) => getNetworksConfiguration(name, params, signal);

  return { queryKey, queryFn, enabled: !!name, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNetworksConfiguration>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNetworksConfigurationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNetworksConfiguration>>
>;
export type GetNetworksConfigurationQueryError = GetNetworkConfigurationErrorResponse;

export function useGetNetworksConfiguration<
  TData = Awaited<ReturnType<typeof getNetworksConfiguration>>,
  TError = GetNetworkConfigurationErrorResponse,
>(
  name: string,
  params: undefined | GetNetworksConfigurationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNetworksConfiguration>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworksConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getNetworksConfiguration>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNetworksConfiguration<
  TData = Awaited<ReturnType<typeof getNetworksConfiguration>>,
  TError = GetNetworkConfigurationErrorResponse,
>(
  name: string,
  params?: GetNetworksConfigurationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNetworksConfiguration>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNetworksConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getNetworksConfiguration>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNetworksConfiguration<
  TData = Awaited<ReturnType<typeof getNetworksConfiguration>>,
  TError = GetNetworkConfigurationErrorResponse,
>(
  name: string,
  params?: GetNetworksConfigurationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNetworksConfiguration>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetNetworksConfiguration<
  TData = Awaited<ReturnType<typeof getNetworksConfiguration>>,
  TError = GetNetworkConfigurationErrorResponse,
>(
  name: string,
  params?: GetNetworksConfigurationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNetworksConfiguration>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNetworksConfigurationQueryOptions(name, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
